<template>
  <div class="d-flex align-items-center">
    <!-- Back to Original User Button (shown when impersonating) - Beside dropdown -->
    <b-button
      v-if="isImpersonating"
      variant="warning"
      size="sm"
      class="mr-2"
      @click="returnToOriginalUser"
      style="white-space: nowrap;"
    >
      <feather-icon size="14" icon="UserCheckIcon" class="mr-1" />
      <span>Back to {{ originalUserName }}</span>
    </b-button>

    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
    >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0" v-if="currentUserData && Object.keys(currentUserData).length > 0">
          {{ currentUserData.fullName || currentUserData.username }}
        </p>
        <!-- <span class="user-status">
          {{ parentName.toUpperCase() }}
        </span> -->
        <span class="user-status" v-if="currentUserData && Object.keys(currentUserData).length > 0"
          >{{ currentUserData.name }} {{ currentUserData.surname }}
        </span>
        <!-- <span class="user-status" v-if="currentUserData.role == 'Admin'"
          >Admin</span
        > -->
        <!-- <span class="user-status" v-else
          >{{ currentUserData.position ?currentUserData.position.name:''}}</span
        > -->
      </div>
      <b-avatar
        size="40"
        :src="currentUserData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
        v-if="currentUserData && Object.keys(currentUserData).length > 0"
      >
        <!-- <feather-icon v-if="!currentUserData.fullName" icon="UserIcon" size="22" /> -->
        <b-img
          v-if="!currentUserData.fullName"
          rounded
          :src="profile"
          style="width: 100%; height: 100%"
        />
      </b-avatar>
    </template>

    <b-dropdown-item
      :to="{ name: 'pages-profile' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>Profile</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MailIcon" class="mr-50" />
      <span>Inbox</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-todo' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
      <span>Task</span>
    </b-dropdown-item>
    <b-dropdown-item
      :to="{ name: 'apps-chat' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
      <span>Chat</span>
    </b-dropdown-item> -->

    <b-dropdown-divider />

    <b-dropdown-item
      :to="{ name: 'setup' }"
      link-class="d-flex align-items-center"
      v-if="userRole === 'admin'"
    >
      <feather-icon size="16" icon="SettingsIcon" class="mr-50" />
      <span>Setup</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'pages-pricing' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="CreditCardIcon" class="mr-50" />
      <span>Pricing</span>
    </b-dropdown-item> -->
    <!-- <b-dropdown-item
      :to="{ name: 'pages-faq' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="HelpCircleIcon" class="mr-50" />
      <span>FAQ</span>
    </b-dropdown-item> -->
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>Logout</span>
    </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BImg,
  BMedia,
  BMediaAside,
  BButton,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
import axios from "@/components/axios";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BImg,
    BMedia,
    BMediaAside,
    BButton,
  },
  data() {
    return {
      parentName: "",
      userData: null,
      accessToken: localStorage.getItem("accessToken"),
      userRole: "",
      baseApi: process.env.VUE_APP_APIENDPOINT,
      profile: "",
      role: "",
      type: "",
      userType: "",
      originalUserData: null,

      avatarText,
    };
  },
  computed: {
    currentUserData() {
      // Make userData reactive by reading from localStorage
      try {
        return JSON.parse(localStorage.getItem("userData") || "{}");
      } catch (e) {
        return {};
      }
    },
    isImpersonating() {
      // Check if original user data exists (backend stores it when impersonating)
      // Check multiple possible locations where backend might store original user info
      
      const userData = this.currentUserData;
      
      // Check for nested originalUser object
      if (userData && userData.originalUser) {
        return true;
      }
      
      // Check for flat fields (original_user_name, original_user_role) - Backend format
      if (userData && userData.original_user_name) {
        return true;
      }
      
      if (this.originalUserData) {
        return true;
      }
      
      // Check localStorage for original user data
      const storedOriginalUser = localStorage.getItem("originalUserData");
      if (storedOriginalUser) {
        try {
          JSON.parse(storedOriginalUser);
          return true;
        } catch (e) {
          return false;
        }
      }
      
      return false;
    },
    originalUserName() {
      const userData = this.currentUserData;
      
      // Check for nested originalUser object first
      if (userData && userData.originalUser) {
        const original = userData.originalUser;
        return original.name || original.username || original.fullName || "Original User";
      }
      
      // Check for flat field original_user_name (backend format)
      if (userData && userData.original_user_name) {
        return userData.original_user_name;
      }
      
      if (this.originalUserData) {
        if (this.originalUserData.original_user_name) {
          return this.originalUserData.original_user_name;
        }
        return this.originalUserData.name || this.originalUserData.username || this.originalUserData.fullName || "Original User";
      }
      
      const storedOriginalUser = localStorage.getItem("originalUserData");
      if (storedOriginalUser) {
        try {
          const original = JSON.parse(storedOriginalUser);
          if (original.original_user_name) {
            return original.original_user_name;
          }
          return original.name || original.username || original.fullName || "Original User";
        } catch (e) {
          return "Original User";
        }
      }
      
      return "Original User";
    },
  },
  mounted() {
    this.loadUserData();
    
    // Listen for storage changes (when userData is updated in other tabs/components)
    window.addEventListener('storage', this.handleStorageChange);
    
    // Also listen for custom event if localStorage is updated in same tab
    this.$root.$on('userDataUpdated', this.loadUserData);
    window.addEventListener('userDataUpdated', this.loadUserData);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('userDataUpdated', this.loadUserData);
    this.$root.$off('userDataUpdated', this.loadUserData);
  },
  watch: {
    // Watch for changes in localStorage to update component
    currentUserData: {
      handler() {
        this.loadUserData();
      },
      deep: true,
    },
  },
  methods: {
    handleStorageChange(e) {
      if (e.key === 'userData' || e.key === 'originalUserData') {
        this.$forceUpdate();
        this.loadUserData();
      }
    },
    loadUserData() {
      const userData = this.currentUserData;
      if (userData && Object.keys(userData).length > 0) {
        this.userData = userData;
        this.userRole = userData.role;
        this.userType = userData.type;
        let arr = this.userRole ? this.userRole.split("") : [];
        if (arr.length > 0) {
          arr[0] = arr[0].toUpperCase();
          this.role = arr.join("");
        }

        let arr2 = this.userType ? this.userType.split("") : [];
        if (arr2.length > 0) {
          arr2[0] = arr2[0].toUpperCase();
          this.type = arr2.join("");
        }
        this.profile = this.$store.state.app.user_data?.profile_image || "";

        // Check for original user data from backend response
        if (userData.originalUser) {
          this.originalUserData = userData.originalUser;
          // Also store in localStorage for persistence
          localStorage.setItem("originalUserData", JSON.stringify(userData.originalUser));
        } else if (userData.original_user_name) {
          // Backend uses flat fields: original_user_name, original_user_role
          // Create originalUser object from flat fields for consistency
          this.originalUserData = {
            id: userData.parent?.id || null,
            name: userData.original_user_name,
            username: userData.parent?.username || null,
            role: userData.original_user_role,
            fullName: userData.original_user_name,
          };
          // Store in localStorage for persistence
          localStorage.setItem("originalUserData", JSON.stringify(this.originalUserData));
        } else {
          // Check localStorage if not in userData (for page reloads)
          const storedOriginalUser = localStorage.getItem("originalUserData");
          if (storedOriginalUser) {
            try {
              this.originalUserData = JSON.parse(storedOriginalUser);
            } catch (e) {
              // Error parsing originalUserData from localStorage
            }
          }
        }
        
        // Force update to ensure computed properties refresh
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    async returnToOriginalUser() {
      try {
        // Get original user data
        let originalUser = null;
        let originalUserId = null;
        
        const userData = this.currentUserData;
        
        if (userData && userData.originalUser) {
          originalUser = userData.originalUser;
          originalUserId = originalUser.id;
        } else if (userData && userData.original_user_name) {
          // Backend uses flat fields - get ID from parent
          originalUserId = userData.parent?.id || null;
          originalUser = {
            id: originalUserId,
            name: userData.original_user_name,
            username: userData.parent?.username || null,
            role: userData.original_user_role,
            fullName: userData.original_user_name,
          };
        } else if (this.originalUserData) {
          originalUser = this.originalUserData;
          originalUserId = originalUser.id;
        } else {
          const storedOriginalUser = localStorage.getItem("originalUserData");
          if (storedOriginalUser) {
            originalUser = JSON.parse(storedOriginalUser);
            originalUserId = originalUser.id;
          }
        }

        if (!originalUser || !originalUserId) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "AlertCircleIcon",
              variant: "danger",
              text: "Original user data not found",
            },
          });
          return;
        }

        // Call backend API to restore original session
        // Try different endpoint variations in case the route is different
        // baseApi might already include /api, so we try both with and without
        const baseApiWithoutApi = this.baseApi.replace(/\/api$/, ''); // Remove trailing /api if present
        const endpointVariations = [
          `${this.baseApi}/auth/return-to-original-user`, // If baseApi includes /api
          `${baseApiWithoutApi}/api/auth/return-to-original-user`, // If baseApi doesn't include /api
          `${this.baseApi}/return-to-original-user`,
          `${baseApiWithoutApi}/api/return-to-original-user`,
          `${this.baseApi}/auth/stop-impersonation`,
        ];
        
        let lastError = null;
        let success = false;
        
        for (const url of endpointVariations) {
          try {
            const requestOptions = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.accessToken}`,
              },
              url: url,
              data: {
                originalUserId: originalUserId,
              },
            };

            const response = await axios(requestOptions);
            
            // If we get here, the request succeeded
            success = true;
            
            // Process the response
            await this.handleReturnToOriginalUserResponse(response, originalUser);
            break;
          } catch (error) {
            lastError = error;
            // If it's not a 404, or if it's the last variation, show the error
            if (error.response?.status !== 404 || url === endpointVariations[endpointVariations.length - 1]) {
              // Continue to next variation if it's a 404, otherwise break
              if (error.response?.status !== 404) {
                break;
              }
            }
          }
        }
        
        // If all variations failed, show error
        if (!success) {
          throw lastError || new Error("Endpoint not found. Please contact administrator to create the backend route.");
        }
      } catch (error) {
        // Show helpful error message
        let errorMessage = "Failed to restore original session";
        if (error.response?.status === 404) {
          errorMessage = "Backend endpoint not found. The route '/api/auth/return-to-original-user' needs to be created on the backend.";
        } else if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "AlertCircleIcon",
            variant: "danger",
            text: errorMessage,
          },
        });
      }
    },
    async handleReturnToOriginalUserResponse(response, originalUser) {
      if (response.data && response.data.token && response.data.user) {
        // Update tokens from response
        useJwt.setToken(response.data.token);
        useJwt.setRefreshToken(response.data.token);

        // Update user data with the restored original user
        const restoredUser = response.data.user;
        localStorage.setItem("userData", JSON.stringify(restoredUser));

        // Remove original user data from localStorage (no longer impersonating)
        localStorage.removeItem("originalUserData");

        // Update ability
        this.$ability.update([
          {
            action: "manage",
            subject: "all",
          },
        ]);

        // Show success message
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Session Restored",
            icon: "CheckIcon",
            variant: "success",
            text: `You have been returned to ${restoredUser.name || restoredUser.username || originalUser.name || originalUser.username}'s account`,
          },
        });

        // Redirect to dashboard based on restored user's role
        const homeRoute = getHomeRouteForLoggedInUser(restoredUser.role);
        this.$router.replace(homeRoute);
        
        // Reload to refresh all data
        location.reload();
      } else {
        throw new Error("Invalid response from server");
      }
    },
    async logout() {
      const requestOptionsUsers = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/logout`,
      };

      await axios(requestOptionsUsers).then((response) => {
        // Get user role before clearing localStorage
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");
        const isAdmin = userData && (userData.role === "admin" || userData.role === "Admin");
        
        // Remove userData from localStorage
        // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

        // Remove userData from localStorage

        const keys = Object.keys(localStorage);
        let i = keys.length;

        while (i--) {
          localStorage.removeItem(`${keys[i]}`);
        }
        // Reset ability
        this.$ability.update(initialAbility);

        // Redirect based on user role
        if (isAdmin) {
          // Admin users should stay on /login/admin after logout
          this.$router.replace({ name: "auth-admin-login" });
        } else {
          // Non-admin users should stay on /login after logout
          this.$router.replace({ name: "auth-login" });
        }
      });
    },
  },
};
</script>
